import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.keys.js";

/*
 * @Author       : Zhelin Cheng
 * @Date         : 2021-04-30 11:27:48
 * @LastEditors  : 程哲林
 * @LastEditTime : 2024-03-20 11:09:08
 * @FilePath     : /marketing-landing-fe/src/services/landing.ts
 * @Description  : 未添加文件描述
 */
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (g && (g = 0, op[0] && (_ = 0)), _) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

import { customError, Sentry } from '@woulsl/sentry-config';
import session from '@woulsl/storage/session';
import sensors from '@woulsl-tools/sensors';
import Cookie from 'js-cookie';
import { CASHBACK_BASE_URL, // CB_BASE_URL,
isJoJoUp, MALL_BASE_URL, ORDER_BASE_URL, ORDER_PAY_BASE_URL, PAY_BASE_URL, TASK_ID, TINMAN_BASE_C_URL, TRACE_BASE_URL } from '@/const';
import { userPopoutModal } from '@/helpers/popout';
import { getNetworkType, isJoJoReadBrowser, qsParse, setSubDomainCookies } from '@/utils';
import bridge from '@/utils/bridge';
import request from '@/utils/request';
import { getTsecTuringDeviceToken } from '@/utils/tsecTuring';
window.__store = window.__store || {};
export function getUserHalfMobile(params) {
  if (params === void 0) {
    params = {};
  }

  return __awaiter(this, void 0, void 0, function () {
    var resp;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4
          /*yield*/
          , request({
            action: '/campaign/getUserHalfMobile',
            baseUrl: CASHBACK_BASE_URL,
            method: 'GET',
            params: params,
            auth: true,
            jumpAuth: false
          })];

        case 1:
          resp = _a.sent();

          if ((resp === null || resp === void 0 ? void 0 : resp.resultCode) === 200) {
            userPopoutModal();
          }

          return [2
          /*return*/
          , resp];
      }
    });
  });
} // campaign/sendSmsMessageCode

export function sendSmsMessageCode(params) {
  if (params === void 0) {
    params = {};
  }

  return request({
    action: '/campaign/sendSmsMessageCode',
    baseUrl: CASHBACK_BASE_URL,
    auth: uc_switch ? false : undefined,
    method: 'POST',
    params: params
  });
}
export function getApolloKey(key) {
  return request({
    action: '/apollo/get-by-key',
    baseUrl: CASHBACK_BASE_URL,
    auth: false,
    params: {
      key: key
    }
  });
} // getSchemeUrl

export function getSchemaUrl(params) {
  if (params === void 0) {
    params = {};
  }

  return request({
    method: 'POST',
    action: '/wechatMiniProgram/getSchemaUrl',
    baseUrl: CASHBACK_BASE_URL,
    auth: uc_switch ? false : undefined,
    params: params
  });
}
export function getWxLinkUrl(params) {
  if (params === void 0) {
    params = {};
  }

  return request({
    method: 'POST',
    action: '/wechatMiniProgram/getWxLinkUrl',
    baseUrl: CASHBACK_BASE_URL,
    auth: false,
    params: params
  });
}
export function getCampaignShow(params, jumpAuth) {
  if (jumpAuth === void 0) {
    jumpAuth = true;
  }

  return request({
    action: '/campaign/show',
    baseUrl: CASHBACK_BASE_URL,
    // auth: jumpAuth ? false : ['jojoApp', 'miniApp', 'wx'],
    auth: jumpAuth || uc_switch ? false : ['jojoApp', 'miniApp', 'wx'],
    params: params,
    jumpAuth: jumpAuth
  });
}
export function classSignUp(params) {
  if (params === void 0) {
    params = {};
  }

  return request({
    action: '/campaign/sign-up',
    baseUrl: CASHBACK_BASE_URL,
    // 报名接口收敛，根据登录状态更新接口
    auth: !!__store.logged,
    params: params
  });
}
export function getQuestion(params) {
  if (params === void 0) {
    params = {};
  }

  return request({
    action: '/campaign/get-question',
    baseUrl: CASHBACK_BASE_URL,
    auth: false,
    params: params
  });
}
export function getComment(params) {
  if (params === void 0) {
    params = {};
  }

  return request({
    action: '/campaign/get-comment',
    baseUrl: CASHBACK_BASE_URL,
    auth: false,
    params: params
  });
}
export function getTraceId(params) {
  if (params === void 0) {
    params = {};
  }

  return request({
    action: '/user/operate/log/getTraceId',
    prefix: '/pc/pc-aegis',
    baseUrl: TRACE_BASE_URL,
    auth: false,
    params: params
  });
}
export function uploadLog(params) {
  if (params === void 0) {
    params = {};
  }

  return request({
    action: '/uploadLog',
    prefix: '/pc/pc-aegis/user/operate/log/noAuth',
    authPrefix: '/pc/pc-aegis/user/operate/log',
    auth: false,
    baseUrl: TRACE_BASE_URL,
    params: params
  });
} // 激活

export function postActiveAddress(params) {
  if (params === void 0) {
    params = {};
  }

  return request({
    action: '/campaign/pick-up-soldid',
    method: 'POST',
    baseUrl: CASHBACK_BASE_URL,
    auth: true,
    params: params
  });
} // 抖音静默授权

export function tiktokVerify(params) {
  if (params === void 0) {
    params = {};
  }

  return request({
    action: '/campaign/get-auth-url',
    method: 'GET',
    baseUrl: CASHBACK_BASE_URL,
    auth: false,
    params: params
  });
} // 获取弹窗列表

export function listPopConfig(params) {
  if (params === void 0) {
    params = {};
  }

  return request({
    action: '/popConfig/list-pop-config',
    method: 'GET',
    baseUrl: CASHBACK_BASE_URL,
    auth: false,
    params: params
  });
} // 获取弹窗列表

export function getWxConfig(params) {
  if (params === void 0) {
    params = {};
  }

  return request({
    action: '/wxmp/create-signature',
    method: 'GET',
    baseUrl: MALL_BASE_URL,
    auth: false,
    prefix: '/api/product/open',
    authPrefix: '/api/fe',
    jumpAuth: false,
    params: params
  });
} // 服务留资保障，保存手机号码

export function saveReport(params) {
  if (params === void 0) {
    params = {};
  }

  return request({
    action: '/custmerCapital/saveReport',
    method: 'POST',
    baseUrl: CASHBACK_BASE_URL,
    auth: uc_switch ? false : undefined,
    params: params
  });
} // 创建订单

export function createOrder(params) {
  var _a;

  if (params === void 0) {
    params = {};
  }

  return __awaiter(this, void 0, void 0, function () {
    var res, href, userInfo;
    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          return [4
          /*yield*/
          , request({
            action: '/campaign/place-order',
            method: 'POST',
            baseUrl: CASHBACK_BASE_URL,
            auth: uc_switch ? !!__store.logged : undefined,
            params: params,
            headers: {
              'TM-UserAgent-TSecTuringDeviceToken': getTsecTuringDeviceToken()
            }
          })];

        case 1:
          res = _b.sent();
          href = window.location.href;

          try {
            if (res.resultCode === 200 && ((_a = res.data) === null || _a === void 0 ? void 0 : _a.userInfo)) {
              userInfo = res.data.userInfo;
              setSubDomainCookies('uid', userInfo.userId || '', {
                expires: 8
              });
              setSubDomainCookies('authToken', userInfo.authToken || '', {
                expires: 8
              });
              setSubDomainCookies('userHashId', userInfo.userHashId || '', {
                expires: 8
              });
              __store.logged = true; // 登录后，这里设置用户UID

              Sentry.setTag('id', userInfo.userId);
            }
          } catch (e) {
            customError({
              name: 'Cookie跨域设置',
              message: '设置错误',
              captureContext: {
                level: 'error',
                extra: {
                  href: href
                }
              }
            });
          }

          return [2
          /*return*/
          , res];
      }
    });
  });
}
/**
 * 检查用户可激活的课程列表
 * @param params
 */

export function getVerificationCode(params) {
  if (params === void 0) {
    params = {};
  }

  return request({
    action: '/campaign/send-verification-code',
    method: 'GET',
    baseUrl: CASHBACK_BASE_URL,
    auth: uc_switch ? false : undefined,
    params: params
  });
}
/**
 * 获取闪验签名方法
 * @param params
 */

export function validateLocalNumber(params) {
  if (params === void 0) {
    params = {};
  }

  return request({
    action: '/getInterfaces/getSign',
    method: 'GET',
    baseUrl: CASHBACK_BASE_URL,
    auth: uc_switch ? false : undefined,
    params: params
  });
}
/**
 * 验证本地手机号
 * @param params
 */

export function verifyVmMobileApi(params) {
  if (params === void 0) {
    params = {};
  }

  return request({
    action: '/getInterfaces/verifyVmMobileApi',
    method: 'GET',
    baseUrl: CASHBACK_BASE_URL,
    auth: uc_switch ? false : undefined,
    params: params
  });
}
/**
 * 获取支付结果
 * @param params
 */

export function getOrderDetail(params) {
  if (params === void 0) {
    params = {};
  }

  return request({
    action: '/campaign/query-pay',
    method: 'GET',
    baseUrl: CASHBACK_BASE_URL,
    auth: uc_switch ? true : undefined,
    params: params
  });
}
/**
 * 获取支付结果
 * @param params
 */

export function getOrderPayDetail(params) {
  if (params === void 0) {
    params = {};
  }

  return request({
    action: '/pull-pay-result',
    method: 'GET',
    prefix: '/noRight/api/fe/pay',
    authPrefix: '/api/fe/pay',
    baseUrl: PAY_BASE_URL,
    params: params
  });
}
export function buriedSetCookie(params) {
  if (params === void 0) {
    params = {};
  }

  return request({
    action: '/campaign/set-cookie-data',
    method: 'POST',
    baseUrl: CASHBACK_BASE_URL,
    auth: false,
    params: params
  });
} // 获取Sku详情

export function showDetail(params) {
  if (params === void 0) {
    params = {};
  }

  return request({
    action: '/campaign/show-detail',
    baseUrl: CASHBACK_BASE_URL,
    auth: !!__store.logged,
    params: params
  });
}
export function skuPreview(params) {
  if (params === void 0) {
    params = {};
  }

  return request({
    action: '/campaign/sku-preview',
    baseUrl: CASHBACK_BASE_URL,
    auth: uc_switch ? false : undefined,
    params: params
  });
}
/**
 * 获取微信支付参数站内
 * @param params
 */

export function getWxPayConfig(params, inner) {
  if (params === void 0) {
    params = {};
  }

  if (inner) {
    return request({
      action: '/pay/create-wechatOrderJSAPI',
      method: 'POST',
      baseUrl: PAY_BASE_URL,
      // auth: false,
      params: params
    });
  } else {
    return request({
      action: '/api/fe/pay/create-wechat-h5-order',
      method: 'POST',
      prefix: '/noRight',
      baseUrl: PAY_BASE_URL,
      auth: false,
      params: params
    });
  }
}
/**
 * 获取微信支付参数站内外（新支付接口）
 * @param params
 */

export function getWxPayConfigByBill(params, inner) {
  if (params === void 0) {
    params = {};
  }

  if (inner) {
    return request({
      action: '/pay/bill-check-out',
      method: 'POST',
      baseUrl: ORDER_PAY_BASE_URL,
      params: params
    });
  } else {
    return request({
      action: '/api/fe/pay/bill-check-out',
      method: 'POST',
      prefix: '/noRight',
      baseUrl: ORDER_PAY_BASE_URL,
      auth: false,
      params: params
    });
  }
}
var reportType = {
  PAGE_SHOW: 'pageShowBo',
  CREATIVE: 'activationBo',
  PAY: 'payBo',
  PAY_SUCCESS: 'paySuccessBo',
  ADD: 'addBo',
  ORDER: 'orderBo'
}; // 事件名

var eventName = {
  browse: '浏览',
  activation: '课程激活',
  add: '添加老师',
  selection: '选课',
  order: '下单',
  pay: '去支付',
  paysuccessful: '支付成功'
};
var eventId = {
  browse: 5,
  activation: 6,
  add: 7,
  selection: 11,
  order: 60,
  pay: 8,
  paysuccessful: 35
};
export function pointReportMsg(event, params) {
  if (params === void 0) {
    params = {};
  }

  return __awaiter(this, void 0, void 0, function () {
    var query, uid, anonymousID, newParams, e_1;

    var _a;

    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          _b.trys.push([0, 2,, 3]);

          query = qsParse();
          uid = Cookie.get('uid') || '';
          anonymousID = sensors && sensors.quick('getAnonymousID') || '';
          newParams = params;

          if (newParams.phone) {
            newParams.phone = btoa(newParams.phone);
          }

          return [4
          /*yield*/
          , request({
            action: '/safeCtrl/point-report-msg',
            method: 'POST',
            baseUrl: CASHBACK_BASE_URL,
            auth: false,
            // prefix: '/noright',
            params: (_a = {
              eventName: event
            }, _a[reportType[event]] = __assign(__assign({
              eventname: eventName[newParams === null || newParams === void 0 ? void 0 : newParams.action] || undefined,
              userid: btoa(uid),
              uuid: btoa(anonymousID),
              pageid: query === null || query === void 0 ? void 0 : query.linkId,
              lastpage: document.referrer,
              currentpage: window.location.href,
              net: getNetworkType(),
              task_id: sessionStorage.getItem(TASK_ID) || ''
            }, newParams), {
              action: eventId[newParams === null || newParams === void 0 ? void 0 : newParams.action] || undefined,
              // 手机号参数覆盖，接口不需要传入手机号
              phone: ''
            }), _a)
          })];

        case 1:
          _b.sent();

          return [2
          /*return*/
          , true];

        case 2:
          e_1 = _b.sent();
          /* customError({
            name: '数据上报接口错误',
            message: 'point-report-msg',
            stack: e?.stack,
            captureContext: {
              level: 'warning'
            }
          }); */

          return [2
          /*return*/
          , false];

        case 3:
          return [2
          /*return*/
          ];
      }
    });
  });
}
export var RECORD_KEY = 'marketing_record_key'; //  落地页埋点后端数据

export function userActionRecord(params) {
  if (params === void 0) {
    params = {};
  }

  return __awaiter(this, void 0, void 0, function () {
    var cachedData, userId, requestParams_1, doRequest, resp, e_2;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          _a.trys.push([0, 4,, 5]);

          cachedData = session.get(RECORD_KEY);

          if (!cachedData) {
            session.set(RECORD_KEY, params);
          }

          userId = Cookie.get('uid') || undefined;
          requestParams_1 = __assign(__assign(__assign({}, cachedData || {}), params), {
            userId: userId,
            url: window.location.href,
            data: __assign(__assign(__assign({}, (cachedData === null || cachedData === void 0 ? void 0 : cachedData.data) || {}), (params === null || params === void 0 ? void 0 : params.data) || {}), {
              sensorAnonymousID: sensors.quick('getAnonymousID') || ''
            })
          });

          doRequest = function doRequest(prefix) {
            return request({
              action: '/action/userActionRecord',
              prefix: prefix,
              baseUrl: TINMAN_BASE_C_URL,
              auth: false,
              method: 'POST',
              params: requestParams_1,
              jumpAuth: false
            });
          };

          return [4
          /*yield*/
          , doRequest("".concat(isJoJoUp ? '/mall/gravity' : '', "/api/gravity/fe"))];

        case 1:
          resp = _a.sent();
          if (![1001, 1005].includes(resp === null || resp === void 0 ? void 0 : resp.status)) return [3
          /*break*/
          , 3];
          return [4
          /*yield*/
          , doRequest("".concat(isJoJoUp ? '/mall/gravity' : '', "/api/gravity/open"))];

        case 2:
          _a.sent();

          _a.label = 3;

        case 3:
          return [2
          /*return*/
          , true];

        case 4:
          e_2 = _a.sent();
          /* customError({
            name: '数据上报接口错误',
            message: 'userActionRecord',
            stack: e?.stack,
            captureContext: {
              level: 'warning'
            }
          }); */

          return [2
          /*return*/
          , false];

        case 5:
          return [2
          /*return*/
          ];
      }
    });
  });
} // 通过groupId 获取appId

export function getAppIdByGroupId(params) {
  if (params === void 0) {
    params = {};
  }

  return request({
    action: "/campaign/getAppIdByGroupId/".concat(params.groupId),
    baseUrl: CASHBACK_BASE_URL,
    auth: false
  });
} //  根据IP查询归属地

export function getCurrentIpAddress() {
  return request({
    action: '/common/getCurrentIpAddress',
    method: 'GET',
    baseUrl: CASHBACK_BASE_URL,
    auth: false
  });
} // 获取微信schemaUrl weixin://xxx

export function getWxSchemaUrl(params) {
  if (params === void 0) {
    params = {};
  }

  return request({
    action: '/wechatMiniProgram/getSchemaUrl',
    method: 'POST',
    baseUrl: CASHBACK_BASE_URL,
    auth: false,
    params: params
  });
}
export function userJoinClass(params, header) {
  if (params === void 0) {
    params = {};
  }

  if (header === void 0) {
    header = {};
  }

  return request({
    action: '/campaign/userJoinClass',
    method: 'POST',
    baseUrl: CASHBACK_BASE_URL,
    auth: true,
    params: params,
    headers: (header === null || header === void 0 ? void 0 : header.state) ? {
      'TM-UserAgent-appUserAuthToken': header.state
    } : {}
  });
}
export function queryClassJoinTask(params, header) {
  if (params === void 0) {
    params = {};
  }

  if (header === void 0) {
    header = {};
  }

  return request({
    action: '/campaign/queryClassJoinTask',
    method: 'POST',
    baseUrl: CASHBACK_BASE_URL,
    auth: true,
    params: params,
    headers: (header === null || header === void 0 ? void 0 : header.state) ? {
      'TM-UserAgent-appUserAuthToken': header.state
    } : {}
  });
}
export function classJoinWay(params, header) {
  if (params === void 0) {
    params = {};
  }

  if (header === void 0) {
    header = {};
  }

  return request({
    action: '/campaign/class-join-way',
    method: 'POST',
    baseUrl: CASHBACK_BASE_URL,
    auth: true,
    params: params,
    headers: (header === null || header === void 0 ? void 0 : header.state) ? {
      'TM-UserAgent-appUserAuthToken': header.state
    } : {}
  });
} // 获取用户协议

export function getProtocolInfoByCampaignPageId(params) {
  if (params === void 0) {
    params = {};
  }

  return request({
    action: '/campaign/getProtocolInfoByCampaignPageId',
    method: 'GET',
    // baseUrl: 'https://mock.xjjj.co/mock/643bb442ad75630011128449/mom',
    baseUrl: CASHBACK_BASE_URL,
    auth: false,
    params: params
  });
} // 获取答题配置

export function getQuestionConfig(params) {
  if (params === void 0) {
    params = {};
  }

  return request({
    action: '/campaign/getQuestions',
    method: 'POST',
    baseUrl: CASHBACK_BASE_URL,
    auth: false,
    params: params
  });
} // 生成短链

export function generateShortUrl(params) {
  if (params === void 0) {
    params = {};
  }

  return request({
    action: '/campaign/generateShortUrl',
    method: 'POST',
    baseUrl: CASHBACK_BASE_URL,
    auth: true,
    params: params
  });
} // 根据答题结果获取sku

export function checkAnswerSku(params) {
  if (params === void 0) {
    params = {};
  }

  return request({
    action: '/campaign/checkAnswerSku',
    method: 'POST',
    baseUrl: CASHBACK_BASE_URL,
    auth: false,
    params: params
  });
} // 获取商城sku信息

export function getMallSkuInfo(params) {
  if (params === void 0) {
    params = {};
  }

  return request({
    action: '/campaign/mall-sku-info',
    method: 'GET',
    baseUrl: CASHBACK_BASE_URL,
    auth: !!__store.logged,
    params: params
  });
}
export function unbindAccount(params) {
  if (params === void 0) {
    params = {};
  }

  return request({
    action: '/user/master-user',
    method: 'DELETE',
    baseUrl: CASHBACK_BASE_URL,
    auth: true,
    params: params
  });
} // 获取促销规则skutoNextStep

export function getMallPromotionSkus(linkCode) {
  return request({
    action: "/promotion-activities/".concat(linkCode, "/goods"),
    method: 'GET',
    baseUrl: CASHBACK_BASE_URL,
    auth: false,
    params: {
      linkCode: linkCode
    }
  });
} // 订单中转sku
// 1. 根据userCourseId获取用户下一步前往信息 /api/fe/users/{userId}/courses/{userCourseId}/forward
// 2. 根据orderId获取用户下一步前往信息 /api/fe/orders/{orderId}/forward
// 3. 根据soldNoteId获取用户下一步前往信息 /api/fe/sold-notes/{soldNoteId}/forward

export function getOrderTransfer(params, header) {
  if (params === void 0) {
    params = {};
  }

  if (header === void 0) {
    header = {};
  }

  var uid = Cookie.get('uid') || '0';
  var actionMap = {
    userCourseId: "/users/".concat(uid, "/courses/").concat(params.userCourseId, "/forward"),
    orderId: "/orders/".concat(params.orderId, "/forward"),
    soldNoteId: "/sold-notes/".concat(params.soldNoteId, "/forward")
  };
  var action = "/orders/".concat(params.orderId, "/forward");
  var actionMapArr = Object.keys(actionMap);

  for (var i = 0, len = actionMapArr.length; i < len; i++) {
    var el = actionMapArr[i];

    if (params === null || params === void 0 ? void 0 : params[el]) {
      action = actionMap[el];
      break;
    }
  }

  return request({
    action: action,
    method: 'POST',
    baseUrl: CASHBACK_BASE_URL,
    auth: true,
    params: params,
    headers: (header === null || header === void 0 ? void 0 : header.state) ? {
      'TM-UserAgent-appUserAuthToken': header.state
    } : {}
  });
}
export function getTeenMode() {
  var packageName = '';
  var isJoJoReadApp = isJoJoReadBrowser();

  if (isJoJoReadApp) {
    packageName = 'com.shusheng.JoJoRead';
  } // JOJOUP 本期不支持
  // if (isJoJoUpApp) {
  //   packageName = 'com.read.box.book';
  // }


  if (!['com.shusheng.JoJoRead', 'com.junior.flawless', 'com.read.box.book'].includes(packageName)) {
    // 跳过未成年人模式判断
    return {
      data: {
        teenModeStatus: 0
      },
      resultCode: 200,
      errorMsg: ''
    };
  }

  return request({
    action: "/user/apps/".concat(packageName, "/teen-mode"),
    method: 'GET',
    baseUrl: CASHBACK_BASE_URL,
    auth: true
  });
} // 获取课时列表

export function getLessons(params) {
  if (params === void 0) {
    params = {};
  }

  return request({
    action: '/lessons',
    method: 'GET',
    baseUrl: CASHBACK_BASE_URL,
    auth: true,
    params: params
  });
}
export function guestPurchase(params) {
  if (params === void 0) {
    params = {};
  }

  return __awaiter(this, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4
          /*yield*/
          , bridge.call('getDeviceInfo')];

        case 1:
          data = _a.sent().data;
          return [2
          /*return*/
          , request({
            action: '/guest/purchases',
            method: 'POST',
            prefix: '/api/fe',
            baseUrl: ORDER_BASE_URL,
            auth: true,
            params: params,
            headers: {
              'X-Device-Id': (data === null || data === void 0 ? void 0 : data.deviceUniqueIdentifier) || '',
              'X-App-Audit': 'true',
              'X-Guest-User': 'true'
            }
          })];
      }
    });
  });
}
export function guestPurchaseNotify(params) {
  if (params === void 0) {
    params = {};
  }

  return request({
    action: "/guest/purchases/".concat(params.id),
    method: 'PUT',
    prefix: '/api/fe',
    baseUrl: ORDER_BASE_URL,
    auth: true,
    params: params
  });
}